import Vue from "vue";
import VueRouter from "vue-router";

import Main from "../views/Main.vue";
import { CacheTool } from "@js/cache-tool.js";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("../views/Login.vue")
    },
    {
      path: "/",
      name: "Main",
      component: Main
    },
    {
      path: "/report",
      name: "Report",
      component: () => import("../views/Report/Report.vue")
    },
    {
      path: "/m11b-report",
      name: "M11BReport",
      component: () => import("../views/M11BReport/M11BReport.vue")
    },
   
    {
      path: "/blood-oxygen-report",
      name: "BloodOxygenReport",
      component: () => import("@c/report-detail/single-blood-oxygen-report/blood-oxygen-report.vue")
    },
    {
      path: "/new-blood-oxygen-report",
      name: "NewBloodOxygenReport",
      component: () => import("@c/report-detail/single-blood-oxygen-report/new-blood-oxygen-report.vue")
    },
    {
      path: "/blood-oxygen-report-print",
      name: "BloodOxygenReportPrint",
      component: () => import("../views/BloodOxygenReportPrint.vue")
    },
    {
      path: "/liangxiang-assessment-report",
      name: "LiangxiangAssessmentReport",
      component: () => import("@c/report-detail/liangxiang-assessment-report/liangxiang-assessment-report.vue")
    },
    {
      path: "/report-sheng-fu-bao",
      name: "ReportShengFuBao",
      component: () => import("../views/Report/ReportShengFuBao.vue")
    },
    {
      path: "/query-result",
      name: "QueryResult",
      component: () => import("../views/QueryResult/QueryResult.vue")
    }
   
   
  ]
});

router.beforeEach((to, from, next) => {
  let loginInfo = CacheTool.getLoginInfo(); 
  if (!loginInfo) {
    const androidLoginInfo = localStorage.getItem('androidLoginInfo')
    const thirdLoginInfo = localStorage.getItem('thirdLoginInfo')
    if (androidLoginInfo) {
      loginInfo = JSON.parse(androidLoginInfo)
    } else if (thirdLoginInfo) {
      loginInfo = JSON.parse(thirdLoginInfo)
    }
  }
  if (to.name === "Report" || to.name === "BloodOxygenReport" || to.name === "QueryResult" || to.name === "LiangxiangAssessmentReport" || to.name === "M11BReport") {
    // 如果要跳转详情，直接进入
    next()
  } else if (loginInfo || to.name === "Login") {
    // 如果存在登录信息,或者不存在登录信息，但进入的页面是登录页面,则直接进入
    next();
  } else {
    // 如果不存在登录信息,则跳转到登录页面.要带上当前的页面地址，方便登录完成后做回跳
    next({
      name: "Login"
    });
  }

});

export default router;
